import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'lib-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginFormGroup: FormGroup;
  formSumitAttempt: boolean;
  @Input() backgroundImage: any;
  photo1;
  @Input() logo: any;
  photo2;
  @Output() getData = new EventEmitter();
  @Output() navigateToForgotPwd = new EventEmitter();
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.photo1 = `url(${this.backgroundImage})`;
    this.photo2 = this.logo;
    this.loginFormGroup = this.fb.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  isFieldValid(field: string) {
    return (
      (!this.loginFormGroup.get(field).valid && this.loginFormGroup.get(field).touched) ||
      (this.loginFormGroup.get(field).untouched && this.formSumitAttempt)
    );
  }

  submit() {
    if (this.loginFormGroup.valid) {
      this.getData.emit(this.loginFormGroup.value);
    } else {
      this.formSumitAttempt = true;
    }
  }

  selectForgotPwd() {
    this.navigateToForgotPwd.emit({ isForgotPwd: true })
  }
}
